import * as React from 'react'

import { FLOOR_10_DATA } from 'floors-data/floor-10-data'
import SVG from 'reusable/SVG'
import {
  renderApartmentArea,
  renderApartmentLabel,
  renderViewCone,
} from 'utils/helper'

export default function Floor10({
  activeApartment,
  changeFloor,
  changeView,
  hLookAt,
  highestFloor,
  lowestFloor,
  apartments,
}) {
  const [elementOnHover, setElementOnHover] = React.useState('')
  const { sceneName, apartmentNumber } = activeApartment

  return (
    <SVG
      id="floor-10"
      viewBox="0 0 440 240"
      highestFloor={highestFloor}
      lowestFloor={lowestFloor}
    >
      <defs>
        <style>
          {`
          .cls-1 {
        fill: url(#linear-gradient);
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #ececec;
      }

      .cls-3, .cls-12, .cls-100 {
        fill: #e6e7e8;
      }

      .cls-4 {
        fill: #505050;
      }

      .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {
        stroke: #000;
        stroke-miterlimit: 10;
      }

      .cls-6 {
        fill-rule: evenodd;
      }

      .cls-6, .cls-11 {
        fill: #143275;
      }

      .cls-13 {
        fill: #b4b4b4;
      }

      .cls-14 {
        fill: none;
      }

      .cls-14, .cls-17 {
        opacity: .5;
      }

      .cls-7, .cls-15 {
        fill: #fff;
      }

      .cls-8, .cls-17 {
        fill: #939598;
      }

      .cls-9 {
        fill: url(#linear-gradient-2);
      }

      .cls-10 {
        fill: url(#linear-gradient-3);
      }

      .cls-16 {
        fill: #c8c8c8;
      }
          `}
        </style>
        <symbol id="arrow_google_down" viewBox="0 0 18.3 18.3">
          <use
            width="18.3"
            height="18.3"
            transform="translate(18.3 18.3) rotate(-180)"
            xlinkHref="#arrow_google_up"
          />
        </symbol>
        <symbol id="arrow_google_up" viewBox="0 0 18.3 18.3">
          <path
            id="arrow_up_2"
            className="cls-11"
            d="m7.45,6.55l-5.05,5.025-2.4-2.425L9.15,0l9.15,9.15-2.4,2.45-5.05-5.05v11.75s-3.4,0-3.4,0V6.55Z"
          />
        </symbol>
        <linearGradient
          id="linear-gradient"
          x1="424.5974"
          y1="-525.523"
          x2="424.5974"
          y2="-568.9351"
          gradientTransform="translate(-164.9032 -440.2159) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".0102" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="387.1096"
          y1="-496.7166"
          x2="387.1096"
          y2="-540.1286"
          gradientTransform="translate(-164.9032 -440.2159) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".0102" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          y1="-471.9946"
          y2="-515.4067"
          xlinkHref="#linear-gradient-2"
        />
      </defs>
      <g id="bg-9" data-name="bg">
        <rect
          id="bg-10"
          data-name="bg"
          className="cls-2"
          width="440"
          height="240"
        />
        <polygon
          id="compass_arrow"
          data-name="compass arrow"
          className="cls-5"
          points="165.39 100.5551 147.5795 113.3885 152.1148 116.9994 134.61 138.9858 135.1866 139.4449 152.6914 117.4585 163.4191 103.9842 156.865 120.7814 157.3569 121.1729 165.39 100.5551"
        />
        <path
          id="skanska_logo"
          className="cls-6"
          d="m387.471,210.9275h2.4783l-1.2465-3.7971-1.2318,3.7971Zm3.8116,4.0725l-.6667-2.0434h-3.7971l-.6667,2.0434h-2.4203l3.5072-10h2.942l3.5072,10h-2.4057Zm-10.4203-10h2.7247l-3.8406,4.9275,3.8406,5.0725h-2.8261l-3.145-4.1739v4.1739h-2.3188v-10h2.3188v4.1885l3.2464-4.1885Zm-9.9855,3.9275c1.9276,0,3.116,1.087,3.116,3.0145,0,1.9131-1.1884,3.058-3.116,3.058h-4.9999v-2.116h4.9711c.6521,0,.9855-.4637.9855-.942s-.3334-.9419-.9855-.9419h-2.2609c-1.9276,0-3.1159-1.1161-3.1159-2.971,0-1.8986,1.1884-3.0291,3.1159-3.0291h4.7102v2.1159h-4.6812c-.6522,0-.9856.4494-.9856.9132,0,.4492.3334.8984.9856.8984h2.2608Zm-9.1159,2.3189v-6.2464h2.3188v10h-2.4057l-3.9711-6.2608v6.2608h-2.3189v-10h2.4058l3.9711,6.2464Zm-13.4493-.3188h2.4783l-1.2464-3.7971-1.2319,3.7971Zm-.2318-5.9275h2.9419l3.5072,10h-2.4058l-.6666-2.0434h-3.7972l-.6665,2.0434h-2.4203l3.5072-10Zm-6.3768,0h2.7246l-3.8406,4.9275,3.8406,5.0725h-2.8261l-3.1449-4.1739v4.1739h-2.3188v-10h2.3188v4.1885l3.2464-4.1885Zm-9.9855,3.942c1.9276,0,3.1159,1.0869,3.1159,3s-1.1884,3.058-3.1159,3.058h-5v-2.1305h4.971c.6522,0,.9856-.4638.9856-.9275,0-.4782-.3333-.9419-.9856-.9419h-2.2609c-1.9276,0-3.1159-1.1161-3.1159-2.971,0-1.8986,1.1884-3.0291,3.1159-3.0291h4.7102v2.1304h-4.6812c-.6522,0-.9855.4493-.9855.8986,0,.4637.3333.913.9855.913h2.2609Z"
        />
        <g>
          <path
            className="cls-11"
            d="m330.6484,34.0195l-1.6797,5.0889h-2.1602l5.4961-16.1777h2.5215l5.5195,16.1777h-2.2324l-1.7285-5.0889h-5.7363Zm5.3047-1.6318l-1.584-4.6562c-.3594-1.0557-.5996-2.0166-.8398-2.9521h-.0488c-.2402.96-.5039,1.9443-.8145,2.9277l-1.5859,4.6807h4.873Z"
          />
          <path
            className="cls-11"
            d="m342.5762,30.6357c0-1.2002-.0234-2.1846-.0957-3.1445h1.8477l.0977,1.8721h.0703c.6484-1.1035,1.7285-2.1357,3.6484-2.1357,1.584,0,2.7852.96,3.2891,2.3281h.0488c.3594-.6484.8145-1.1523,1.2949-1.5127.6973-.5273,1.4648-.8154,2.5684-.8154,1.5371,0,3.8164,1.0078,3.8164,5.04v6.8408h-2.0645v-6.5762c0-2.2324-.8164-3.5771-2.5195-3.5771-1.2012,0-2.1367.8887-2.4961,1.9209-.0957.2881-.168.6719-.168,1.0557v7.1768h-2.0645v-6.9609c0-1.8477-.8164-3.1924-2.4238-3.1924-1.3203,0-2.2812,1.0566-2.6172,2.1123-.1191.3125-.168.6729-.168,1.0322v7.0088h-2.0645v-8.4727Z"
          />
          <path
            className="cls-11"
            d="m362.4961,39.1084c.0488-.792.0957-1.9678.0957-3v-14.041h2.0879v7.2959h.0488c.7441-1.2959,2.0879-2.1357,3.9609-2.1357,2.8789,0,4.9199,2.4004,4.8965,5.9287,0,4.1523-2.6172,6.2158-5.209,6.2158-1.6797,0-3.0234-.6475-3.8887-2.1836h-.0723l-.0957,1.9199h-1.8242Zm2.1836-4.6562c0,.2637.0488.5283.0977.7676.4082,1.4648,1.6309,2.4727,3.168,2.4727,2.207,0,3.5273-1.7998,3.5273-4.4648,0-2.3281-1.1992-4.3203-3.4551-4.3203-1.4414,0-2.7852.9844-3.2168,2.5928-.0488.2402-.1211.5273-.1211.8643v2.0879Z"
          />
          <path
            className="cls-11"
            d="m376.248,31.1152c0-1.3672-.0234-2.5439-.0957-3.624h1.8477l.0723,2.2803h.0957c.5293-1.5596,1.8008-2.5439,3.2168-2.5439.2402,0,.4082.0234.5996.0723v1.9922c-.2148-.0488-.4316-.0723-.7188-.0723-1.4883,0-2.5449,1.1279-2.832,2.7119-.0488.2881-.0977.624-.0977.9844v6.1924h-2.0879v-7.9932Z"
          />
          <path
            className="cls-11"
            d="m390.4082,39.1084l-.168-1.4639h-.0723c-.6465.9121-1.8945,1.7275-3.5508,1.7275-2.3535,0-3.5527-1.6562-3.5527-3.3359,0-2.8086,2.4961-4.3447,6.9844-4.3203v-.2402c0-.96-.2637-2.6885-2.6406-2.6885-1.0801,0-2.207.3369-3.0234.8643l-.4805-1.3916c.9609-.624,2.3516-1.0322,3.8164-1.0322,3.5527,0,4.416,2.4238,4.416,4.752v4.3447c0,1.0078.0488,1.9922.1914,2.7842h-1.9199Zm-.3105-5.9287c-2.3047-.0479-4.9219.3604-4.9219,2.6162,0,1.3682.9121,2.0166,1.9922,2.0166,1.5137,0,2.4727-.96,2.8086-1.9443.0723-.2158.1211-.4561.1211-.6719v-2.0166Z"
          />
        </g>
        <g>
          <path
            className="cls-8"
            d="m427.2402,164.7461v1.8457h-.666v-4.4922h.666v1.8545h5.4004v.792h-5.4004Z"
          />
          <path
            className="cls-8"
            d="m427.0586,160.6787c.2715-.0098.4863.1885.4863.5039,0,.2793-.2148.4766-.4863.4766-.2773,0-.4941-.207-.4941-.4951,0-.2969.2168-.4854.4941-.4854Zm5.582.8818h-4.3574v-.792h4.3574v.792Z"
          />
          <path
            className="cls-8"
            d="m430.6074,159.0137c1.0703-.0176,1.5117-.7021,1.5117-1.4941,0-.5674-.0996-.9092-.2246-1.2061l.5664-.1357c.127.2793.2695.7568.2695,1.4502,0,1.3408-.8809,2.1426-2.1953,2.1426s-2.3496-.7744-2.3496-2.0439c0-1.4229,1.25-1.8008,2.0527-1.8008.1621,0,.2871.0186.3691.0273v3.0605Zm-.5684-2.3223c-.5039-.0088-1.2871.207-1.2871,1.0986,0,.8008.7383,1.1523,1.2871,1.2148v-2.3135Z"
          />
          <path
            className="cls-8"
            d="m427.0332,153.9922h1.25v-1.1348h.6035v1.1348h2.3496c.541,0,.8457-.1533.8457-.5947,0-.207-.0254-.3594-.0527-.459l.5938-.0361c.0625.1533.1074.3965.1074.7021,0,.3691-.1172.667-.332.8555-.2344.2256-.6211.3066-1.1348.3066h-2.377v.6748h-.6035v-.6748h-1.043l-.207-.7744Z"
          />
          <path
            className="cls-8"
            d="m430.4258,148.0771c1.6113,0,2.3145,1.1162,2.3145,2.1699,0,1.1797-.8652,2.0889-2.2422,2.0889-1.459,0-2.3125-.9551-2.3125-2.1611,0-1.251.9082-2.0977,2.2402-2.0977Zm.0449,3.457c.9551,0,1.6758-.5488,1.6758-1.3232,0-.7559-.7109-1.3232-1.6934-1.3232-.7383,0-1.6738.3691-1.6738,1.3057,0,.9355.8633,1.3408,1.6914,1.3408Z"
          />
          <path
            className="cls-8"
            d="m432.6406,144.667l-.5488.0635v.0273c.3418.2422.6484.7109.6484,1.332,0,.8818-.6211,1.332-1.252,1.332-1.0527,0-1.6289-.9355-1.6191-2.6191h-.0918c-.3594,0-1.0078.0986-1.0078.9902,0,.4053.127.8281.3242,1.1338l-.5215.1807c-.2344-.3604-.3867-.8828-.3867-1.4316,0-1.332.9082-1.6562,1.7812-1.6562h1.6309c.377,0,.7461-.0186,1.043-.0723v.7197Zm-2.2227.1172c-.0176.8643.1348,1.8457.9805,1.8457.5137,0,.7559-.3418.7559-.7471,0-.5674-.3594-.9277-.7285-1.0537-.082-.0264-.1719-.0449-.252-.0449h-.7559Z"
          />
          <path
            className="cls-8"
            d="m431.7324,140.8975c.1426-.2256.3691-.748.3691-1.2969,0-1.0176-.6484-1.332-1.1348-1.3232-.8203.0088-1.1699.7471-1.1699,1.5127v.4404h-.5957v-.4404c0-.5762-.2969-1.3057-.9902-1.3057-.4668,0-.8809.2969-.8809,1.0264,0,.4678.207.918.3867,1.1699l-.5762.207c-.2246-.3057-.4512-.9004-.4512-1.5303,0-1.1523.6855-1.6748,1.3965-1.6748.6035,0,1.1152.3604,1.377,1.0811h.0176c.1445-.7207.6855-1.3057,1.5039-1.3057.9355,0,1.7559.7295,1.7559,2.1338,0,.6572-.207,1.2334-.3965,1.5215l-.6113-.2158Z"
          />
          <path
            className="cls-8"
            d="m427.3477,133.1289c-.0098.1621,0,.3691.0352.5938.207,1.2432,1.1172,1.9004,2.0801,2.0352v-.0273c-.3691-.2793-.6758-.7646-.6758-1.4131,0-1.0352.748-1.7646,1.8906-1.7646,1.0723,0,2.0625.7295,2.0625,1.9443,0,1.252-.9727,2.0713-2.4941,2.0713-1.1523,0-2.0605-.4141-2.6367-.9902-.4785-.4863-.7754-1.1348-.8652-1.873-.0352-.2344-.0449-.4316-.0449-.5762h.6484Zm3.375.2246c-.8359,0-1.3398.4775-1.3398,1.207,0,.4766.2969.918.7188,1.1338.0898.0547.207.0908.3516.0908.9629-.0186,1.6758-.46,1.6758-1.2881,0-.6836-.5684-1.1436-1.4062-1.1436Z"
          />
          <path
            className="cls-8"
            d="m429.6523,127.9639c1.9902,0,3.0879.7383,3.0879,2.0342,0,1.1436-1.0723,1.918-3.0078,1.9355-1.9609,0-3.043-.8457-3.043-2.0342,0-1.2334,1.0996-1.9355,2.9629-1.9355Zm.0898,3.1777c1.5215,0,2.3867-.4678,2.3867-1.1885,0-.8105-.9453-1.1973-2.4414-1.1973-1.4395,0-2.3848.3691-2.3848,1.1885,0,.6934.8457,1.1973,2.4395,1.1973Z"
          />
          <path
            className="cls-8"
            d="m429.9766,119.9346c-.8457.0449-1.8633.0996-2.6191.0898v.0273c.7109.207,1.4668.459,2.3047.7656l2.9434,1.0713v.5938l-2.8906.9814c-.8555.2881-1.6387.5312-2.3574.7021v.0176c.7559.0186,1.7734.0635,2.6816.1172l2.6016.1621v.7471l-6.0664-.4229v-.999l2.9336-1.0352c.748-.2529,1.4141-.46,2.0449-.6123v-.0273c-.6133-.1533-1.2793-.3691-2.0449-.6387l-2.9336-1.0811v-.999l6.0664-.3779v.7646l-2.6641.1533Z"
          />
          <path
            className="cls-8"
            d="m432.6406,115.373l-.5488.0635v.0273c.3418.2432.6484.7109.6484,1.332,0,.8818-.6211,1.332-1.252,1.332-1.0527,0-1.6289-.9355-1.6191-2.6191h-.0918c-.3594,0-1.0078.0986-1.0078.9902,0,.4053.127.8281.3242,1.1338l-.5215.1807c-.2344-.3604-.3867-.8828-.3867-1.4316,0-1.332.9082-1.6562,1.7812-1.6562h1.6309c.377,0,.7461-.0186,1.043-.0723v.7197Zm-2.2227.1172c-.0176.8643.1348,1.8457.9805,1.8457.5137,0,.7559-.3418.7559-.7471,0-.5674-.3594-.9277-.7285-1.0537-.082-.0264-.1719-.0449-.252-.0449h-.7559Z"
          />
          <path
            className="cls-8"
            d="m427.0586,112.5664c.2715-.0098.4863.1885.4863.5039,0,.2793-.2148.4766-.4863.4766-.2773,0-.4941-.207-.4941-.4951,0-.2969.2168-.4854.4941-.4854Zm5.582.8818h-4.3574v-.792h4.3574v.792Z"
          />
          <path
            className="cls-8"
            d="m431.8301,111.4502c.1543-.2344.3164-.6484.3164-1.0449,0-.5762-.2891-.8457-.6484-.8457-.3789,0-.5859.2246-.8008.8096-.2793.7832-.7129,1.1523-1.2344,1.1523-.7012,0-1.2773-.5664-1.2773-1.5029,0-.4414.125-.8281.2695-1.0713l.5762.1982c-.1074.1709-.252.4854-.252.8906,0,.4688.2695.7295.5938.7295.3594,0,.5215-.2607.7383-.8281.2891-.7559.666-1.1436,1.3145-1.1436.7656,0,1.3047.5947,1.3047,1.6299,0,.4766-.1172.918-.2969,1.2236l-.6035-.1973Z"
          />
          <path
            className="cls-8"
            d="m430.6074,107.3369c1.0703-.0176,1.5117-.7021,1.5117-1.4941,0-.5674-.0996-.9092-.2246-1.2061l.5664-.1357c.127.2793.2695.7568.2695,1.4502,0,1.3408-.8809,2.1426-2.1953,2.1426s-2.3496-.7744-2.3496-2.0439c0-1.4229,1.25-1.8008,2.0527-1.8008.1621,0,.2871.0186.3691.0273v3.0605Zm-.5684-2.3223c-.5039-.0088-1.2871.207-1.2871,1.0986,0,.8008.7383,1.1523,1.2871,1.2148v-2.3135Z"
          />
          <path
            className="cls-8"
            d="m429.4629,103.2686c-.4492,0-.8184.0088-1.1797.0361v-.6934l.7031-.0361v-.0264c-.4141-.2432-.8008-.6484-.8008-1.3691,0-.5938.3594-1.0439.873-1.2334v-.0176c-.2441-.1348-.4336-.3066-.5684-.4863-.1973-.2607-.3047-.5488-.3047-.9629,0-.5762.377-1.4316,1.8906-1.4316h2.5645v.7744h-2.4668c-.8359,0-1.3418.3057-1.3418.9453,0,.4502.334.8008.7207.9355.1094.0361.252.0635.3965.0635h2.6914v.7744h-2.6094c-.6934,0-1.1992.3057-1.1992.9092,0,.4951.3965.8555.793.9814.1172.0449.252.0625.3867.0625h2.6289v.7744h-3.1777Z"
          />
          <path
            className="cls-8"
            d="m432.6406,93.3496l-.5488.0635v.0273c.3418.2432.6484.7109.6484,1.332,0,.8818-.6211,1.332-1.252,1.332-1.0527,0-1.6289-.9355-1.6191-2.6191h-.0918c-.3594,0-1.0078.0986-1.0078.9902,0,.4053.127.8281.3242,1.1338l-.5215.1807c-.2344-.3604-.3867-.8828-.3867-1.4316,0-1.332.9082-1.6562,1.7812-1.6562h1.6309c.377,0,.7461-.0186,1.043-.0723v.7197Zm-2.2227.1172c-.0176.8643.1348,1.8457.9805,1.8457.5137,0,.7559-.3418.7559-.7471,0-.5674-.3594-.9277-.7285-1.0537-.082-.0264-.1719-.0449-.252-.0449h-.7559Z"
          />
          <path
            className="cls-8"
            d="m430.2832,90.6416v-.0176c-.1543-.1084-.3438-.2617-.4961-.3877l-1.5039-1.2783v-.9541l1.793,1.6836,2.5645-1.918v.9639l-2.0879,1.5029.4492.4053h1.6387v.7832h-6.3906v-.7832h4.0332Z"
          />
          <path
            className="cls-8"
            d="m430.4258,83.2607c1.6113,0,2.3145,1.1162,2.3145,2.1699,0,1.1797-.8652,2.0889-2.2422,2.0889-1.459,0-2.3125-.9551-2.3125-2.1611,0-1.251.9082-2.0977,2.2402-2.0977Zm.0449,3.457c.9551,0,1.6758-.5488,1.6758-1.3232,0-.7559-.7109-1.3232-1.6934-1.3232-.7383,0-1.6738.3691-1.6738,1.3057,0,.9355.8633,1.3408,1.6914,1.3408Z"
          />
          <path
            className="cls-8"
            d="m429.4629,82.2627c-.4492,0-.8184.0088-1.1797.0361v-.7021l.7207-.0449v-.0186c-.4141-.2158-.8184-.7197-.8184-1.4404,0-.6025.3594-1.5391,1.8535-1.5391h2.6016v.792h-2.5117c-.7012,0-1.2871.2617-1.2871,1.0088,0,.5215.3691.9268.8105,1.0615.0996.0361.2344.0547.3691.0547h2.6191v.792h-3.1777Z"
          />
          <path
            className="cls-8"
            d="m430.6074,76.8271c1.0703-.0176,1.5117-.7021,1.5117-1.4941,0-.5674-.0996-.9092-.2246-1.2061l.5664-.1357c.127.2793.2695.7568.2695,1.4502,0,1.3408-.8809,2.1426-2.1953,2.1426s-2.3496-.7744-2.3496-2.0439c0-1.4229,1.25-1.8008,2.0527-1.8008.1621,0,.2871.0186.3691.0273v3.0605Zm-.5684-2.3223c-.5039-.0088-1.2871.207-1.2871,1.0986,0,.8008.7383,1.1523,1.2871,1.2148v-2.3135Z"
          />
        </g>
        <polygon
          id="house_base_1"
          className="cls-17"
          points="16.3889 37.2778 23.7361 35.3472 102.5278 14.4375 272.7292 14.4226 290.625 210.8194 194.1111 219.5556 192.7847 168.6181 248.875 163.3125 240 65.4167 109.4583 65.3958 29.5 86.5 16.3889 37.2778"
        />
        <polygon
          id="house_base_2"
          className="cls-17"
          points="192.7847 168.6181 194.1111 219.5556 24.1944 213.1111 28.5387 102.4956 71.5568 104.1215 69.3207 163.8715 192.7847 168.6181"
        />
        <polygon
          className="cls-16"
          points="16.3889 37.2778 102.5278 14.4375 195.25 14.4375 195.25 65.3958 109.4583 65.3958 29.5 86.5 16.3889 37.2778"
        />
        <polygon
          className="cls-16"
          points="28.5387 102.4956 71.5568 104.1215 69.3207 163.8715 192.7847 168.6181 248.875 163.3125 243.9139 108.5886 281.0079 105.2771 290.625 210.8194 194.1111 219.5556 24.1944 213.1111 28.5387 102.4956"
        />
        <rect
          className="cls-13"
          x="195.25"
          y="14.4375"
          width="11.5833"
          height="50.9583"
        />
        <polygon
          className="cls-13"
          points="280.0702 94.8181 281.0079 105.2771 243.9139 108.5886 242.9634 98.1044 280.0702 94.8181"
        />
      </g>
      <g id="apartments">
        {FLOOR_10_DATA.map(({ floor, name, area }) =>
          renderApartmentArea(
            floor,
            name,
            area,
            changeView,
            setElementOnHover,
            sceneName,
            elementOnHover,
            apartments,
          ),
        )}
      </g>
      <g id="borders_extra-9" data-name="borders_extra">
        <line
          className="cls-12"
          x1="242.9634"
          y1="98.1044"
          x2="280.0702"
          y2="94.8181"
        />
        <line
          className="cls-14"
          x1="69.3207"
          y1="163.8715"
          x2="68.2094"
          y2="163.8274"
        />
        <line
          className="cls-15"
          x1="110.75"
          y1="65.3958"
          x2="240"
          y2="65.4167"
        />
        <line
          className="cls-12"
          x1="206.8333"
          y1="14.4375"
          x2="206.8333"
          y2="65.3958"
        />
        <line
          className="cls-12"
          x1="240"
          y1="65.4167"
          x2="241.6505"
          y2="83.6228"
        />
        <line
          className="cls-12"
          x1="240"
          y1="65.4167"
          x2="277.3739"
          y2="65.3958"
        />
        <line className="cls-12" x1="240" y1="14.4226" x2="240" y2="65.4167" />
      </g>
      <g id="view">
        {FLOOR_10_DATA.map(({ name, viewCone }) =>
          renderViewCone(name, viewCone, hLookAt, apartmentNumber),
        )}
      </g>
      <g id="elevator">
        <g id="bg_tausta" data-name="bg tausta">
          <path
            className="cls-11"
            d="m380,155c0,11-9,20-20,20h0c-11,0-20-9-20-20v-70c0-11,9-20,20-20h0c11,0,20,9,20,20v70Z"
          />
        </g>
        <g
          id="down"
          {...(lowestFloor ? {} : { onClick: () => changeFloor('down') })}
        >
          <g id="bg-11" data-name="bg">
            <circle className="cls-100" cx="360" cy="155" r="17" />
          </g>
          {!lowestFloor && (
            <use
              width="18.3"
              height="18.3"
              transform="translate(350.85 145.85)"
              xlinkHref="#arrow_google_down"
            />
          )}
        </g>
        <g
          id="up"
          {...(highestFloor ? {} : { onClick: () => changeFloor('up') })}
        >
          <g id="bg-12" data-name="bg">
            <circle className="cls-100" cx="360" cy="85" r="17" />
          </g>
          {!highestFloor && (
            <use
              width="18.3"
              height="18.3"
              transform="translate(350.85 75.85)"
              xlinkHref="#arrow_google_up"
            />
          )}
        </g>
        <g>
          <path
            className="cls-7"
            d="m352.7988,112.2754h-.0527l-2.9375,1.5859-.4424-1.7422,3.6924-1.9756h1.9502v16.9004h-2.21v-14.7686Z"
          />
          <path
            className="cls-7"
            d="m372.4023,118.4111c0,5.7471-2.1318,8.9189-5.876,8.9189-3.3018,0-5.5381-3.0947-5.5908-8.6846,0-5.668,2.4443-8.7881,5.877-8.7881,3.5615,0,5.5898,3.1719,5.5898,8.5537Zm-9.1777.2607c0,4.3936,1.3516,6.8896,3.4316,6.8896,2.3398,0,3.458-2.7295,3.458-7.0459,0-4.1602-1.0654-6.8906-3.4316-6.8906-2.0029,0-3.458,2.4443-3.458,7.0469Z"
          />
        </g>
      </g>
      <g id="apartment_nr">
        {FLOOR_10_DATA.map(({ floor, name, namePaths }) =>
          renderApartmentLabel(
            floor,
            name,
            namePaths,
            changeView,
            setElementOnHover,
            apartments,
          ),
        )}
      </g>
    </SVG>
  )
}
